import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    width: 'auto',
    height: 25,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      src="/ciclusrio-logo-cropped.svg"
      alt="CiclusRio Logo"
      className={classes.logo}
    />
  );
};

export default LogoIcon;
